(() => {
  'use strict';
  if (customElements.get('hh-pdp-purchase-credentials')) return;
  const held = new Set(['44641620099357','44641507344669','44641507377437','44641507410205','49903010971933','49903010971901']);
  class PurchaseCredentials extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.root = this.closest('[data-hh-pdp],.product-info');
      if (!this.root) return;
      this.sync = () => {
        if (!this.isConnected) return;
        const select = this.root.querySelector('[data-hh-pdp-variant-select]');
        const form = this.dataset.formId ? document.getElementById(this.dataset.formId) : this.root.querySelector('[data-hh-pdp-form],form[action*="/cart/add"]');
        const input = form?.querySelector('[name="id"]');
        const id = String(select?.value || input?.value || '');
        this.hidden = !/^\d+$/.test(id) || held.has(id);
      };
      this.onChange = () => queueMicrotask(this.sync);
      this.root.addEventListener('change', this.onChange);
      window.addEventListener('popstate', this.onChange);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.root, {subtree:true,childList:true,attributes:true,attributeFilter:['value']});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.root?.removeEventListener('change', this.onChange);
      window.removeEventListener('popstate', this.onChange);
    }
  }
  customElements.define('hh-pdp-purchase-credentials', PurchaseCredentials);
})();
